import SingleChoiceQuestionPage from '@app-studio-web/ui/pages/SingleChoiceQuestionPage'
import { AnswerType } from '@app-studio-web/ui/types'
import useUpdateMode from '@hooks/useUpdateMode'
import { saveAnswer } from '@utils/onboardingStorage'
import { useSearchParams } from 'react-router-dom'

const QUESTION_KEY = 'alcohol'

const answers: AnswerType[] = [
  {
    emoji: '🚫',
    title: 'pages.onboarding.alcohol.options.none',
    value: 'none',
  },
  {
    emoji: '🥂',
    title: 'pages.onboarding.alcohol.options.oneToThree',
    value: '1_to_3',
  },
  {
    emoji: '🍷',
    title: 'pages.onboarding.alcohol.options.fourToSeven',
    value: '4_to_7',
  },
  {
    emoji: '🍺',
    title: 'pages.onboarding.alcohol.options.moreThanSeven',
    value: 'more_than_7',
  },
]

export default function AlcoholPage() {
  const [searchParams] = useSearchParams()
  const urlValue = searchParams.get('value')
  const preselectedValue =
    urlValue && answers.some((a) => a.value === urlValue) ? urlValue : undefined
  const { isUpdate, postToReactNative } = useUpdateMode()

  const onSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    const input = event.target as HTMLInputElement
    const answerValue = input.value

    if (!answerValue) return

    const answer = {
      question_key: QUESTION_KEY,
      question: 'How much alcohol do you drink per week?',
      answer_key: answerValue,
      answer: answerValue,
    }

    if (isUpdate) {
      postToReactNative(answer)
    } else {
      saveAnswer(QUESTION_KEY, answer)
    }
  }

  return (
    <SingleChoiceQuestionPage
      answers={answers}
      title="pages.onboarding.alcohol.heading"
      subtitle="pages.onboarding.alcohol.description"
      preselectedValue={preselectedValue}
      onSubmit={onSubmit}
    />
  )
}
